import React from "react";
import { Route } from "react-router-dom";
import HomePage from "./home-page/HomePage";

export default () => [
  <Route path="vestillion" key="vestillion" element={<HomePage />} />,
  <Route path="vestillion/homepage" key="vestillion" element={<HomePage />} />,
];
